export default {"src":"https://webcdn.trailways.com/_next/static/media/trailways-large.dfe7523e.svg","height":40,"width":169,"blurWidth":0,"blurHeight":0};